import L from 'leaflet';
import proj4 from 'proj4';
import { type ReactElement } from 'react';
import { toWgs84 } from 'reproject';
import { createTravelTimeLayer, maskArea, roadSituation } from '../LayerFactories';
import { LeafletMap } from '../Map';

import type { PageMapProps } from './types';

interface LandingPageMapProps extends PageMapProps {
    pageId: number;
    sweref99GeoArea: string;
}

export const LandingPageMap = (props: LandingPageMapProps): ReactElement => {
    const mapProps = props.mapSettings;
    const setupMap = (map: L.Map): void => {
        const region = mapProps.region.toLowerCase();

        const geoJson = JSON.parse(props.sweref99GeoArea);
        // The reproject below will calculate the bbox if the property exists so we need to set it here
        geoJson.bbox = geoJson.bbox ?? [];
        const area = toWgs84(geoJson, '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs', proj4);

        maskArea([area.geometry], { fillOpacity: 0.2 }).addTo(map);
        roadSituation(region, props.pageId).addTo(map);
        createTravelTimeLayer(region).addTo(map);

        map.fitBounds(L.latLngBounds(L.latLng(area.bbox[1], area.bbox[0]), L.latLng(area.bbox[3], area.bbox[2])));
    };

    return <LeafletMap {...mapProps} onMapInitiated={setupMap} />;
};
